module.exports = __webpack_public_path__ + "static/media/PremiumBeat_0013_cursor_click_06.03acefdb.wav";